// frontend/src/hooks/useAuthFetch.js

import axios from 'axios';
import { useContext, useMemo } from 'react';
import { AuthContext } from '../AuthContext';

export default function useAuthFetch() {
    const { token } = useContext(AuthContext);

    // Memoize the Axios instance so it only updates when `token` changes
    const instance = useMemo(() => {
        return axios.create({
            baseURL: process.env.REACT_APP_API_URL || "/",
            headers: {
                Authorization: token ? `Bearer ${token}` : "",
            },
        });
    }, [token]);

    return instance;
}
